import { lazy, startTransition } from 'react';

export const iconMap = {
  cancel: lazy(() => import('hugeicons-react').then((module) => ({ default: module.Cancel01Icon }))),
  login: lazy(() => import('hugeicons-react').then((module) => ({ default: module.Login01Icon }))),
  plus: lazy(() => import('hugeicons-react').then((module) => ({ default: module.PlusSignIcon }))),
  add: lazy(() => import('hugeicons-react').then((module) => ({ default: module.AddSquareIcon }))),
  info: lazy(() => import('hugeicons-react').then((module) => ({ default: module.InformationCircleIcon }))),
  accept: lazy(() => import('hugeicons-react').then((module) => ({ default: module.CheckmarkSquare04Icon }))),
  home: lazy(() => import('hugeicons-react').then((module) => ({ default: module.Home05Icon }))),
  contact: lazy(() => import('hugeicons-react').then((module) => ({ default: module.Contact01Icon }))),
  project: lazy(() => import('hugeicons-react').then((module) => ({ default: module.Projector01Icon }))),
  back: lazy(() => import('hugeicons-react').then((module) => ({ default: module.ArrowLeft01Icon }))),
  transaction: lazy(() => import('hugeicons-react').then((module) => ({ default: module.MoneyExchange02Icon }))),
  eye: lazy(() => import('hugeicons-react').then((module) => ({ default: module.EyeIcon }))),
  trash: lazy(() => import('hugeicons-react').then((module) => ({ default: module.Delete01Icon }))),
};

export default iconMap;
